<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>约课管理</Breadcrumb-item>
        <Breadcrumb-item>老师代课记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col span="6">
          <Form-item label="上课时间">
            <Row>
              <Col span="11">
              <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                           @on-change="startTimeDateChange"
                           v-model="queryParam.startTimeDate"></Date-picker>
              </Col>
              <Col span="2" style="text-align: center">-</Col>
              <Col span="11">
              <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                           @on-change="endTimeDateChange"
                           v-model="queryParam.endTimeDate"></Date-picker>
              </Col>
            </Row>
          </Form-item>
          </Col>
<!--          <Col span="6">-->
<!--          <Form-item label="学导" >-->
<!--            <Input placeholder="支持模糊搜索" name="studyAdviserNickname"-->
<!--                   v-model="queryParam.studyAdviserNickname"></Input>-->
<!--          </Form-item>-->
<!--          </Col>-->
<!--          <Col span="6">-->
<!--          <Form-item label="外管">-->
<!--            <Input placeholder="支持模糊搜索" name="adviserNickname"-->
<!--                   v-model="queryParam.adviserNickname"></Input>-->
<!--          </Form-item>-->
<!--          </Col>-->
          <Col span="6">
          <Form-item label="原老师ID" >
            <Input name="tchId"
                   v-model="queryParam.oldTchId"></Input>
          </Form-item>
          </Col>
          <Col span="6">
          <Form-item label="代课类型" >
           <Select v-model="queryParam.type">
             <Option value="老师请假-人工代课">老师请假-人工代课</Option>
             <Option value="老师请假-自动代课">老师请假-自动代课</Option>
             <Option value="更换老师">更换老师</Option>
           </Select>
          </Form-item>
          </Col>
<!--          <Col span="6">-->
<!--          <Form-item label="原老师姓名">-->
<!--            <Input placeholder="支持模糊搜索" name="tchName"-->
<!--                   v-model="queryParam.oldTchName"></Input>-->
<!--          </Form-item>-->
<!--          </Col>-->
          <Col span="6">
          <Form-item label="新老师ID" >
            <Input name="tchId"
                   v-model="queryParam.newTchId"></Input>
          </Form-item>
          </Col>
<!--          <Col span="6">-->
<!--          <Form-item label="新老师姓名">-->
<!--            <Input placeholder="支持模糊搜索" name="tchName"-->
<!--                   v-model="queryParam.newTchName"></Input>-->
<!--          </Form-item>-->
<!--          </Col>-->

          <Col span="6">
          <Form-item label="学生ID" >
            <Input name="uid" v-model="queryParam.uid"></Input>
          </Form-item>
          </Col>
          <Col span="6">
          <Form-item label="学生昵称" >
            <Input placeholder="支持模糊搜索" name="userNickname"
                   v-model="queryParam.userNickname"></Input>
          </Form-item>
          </Col>
          <Col span="6">
          <Form-item label="学生手机号" >
            <Input placeholder="支持模糊搜索" name="userMobile"
                   v-model="queryParam.userMobile"></Input>
          </Form-item>
          </Col>
<!--          <Col span="6">-->
<!--            <Form-item label="课程类别">-->
<!--              <Select v-model.number="queryParam.courseType" placeholder="全部"-->
<!--                      @on-change="search" clearable>-->
<!--                <Option v-for="item in $constant.courseType"-->
<!--                        :value="item.code" :key="item.code">{{ item.text }}</Option>-->
<!--              </Select>-->
<!--            </Form-item>-->
<!--          </Col>-->
          <Col span="6">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search" >搜索</Button>
            <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
                    @click="exportData" >导出</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="tchChange/list"
           :params="queryParam" :onLoading="onLoading" :reloadWithPage="reloadWithPage" operator=""></List>
    <SearchChangeTchModal :optType="optType" :user="tempLessonUser" :changeTeacherOnly="changeTeacherOnly" v-model="showSearchChangeTchModal" :successCallback="searchWithPage"></SearchChangeTchModal>
  </div>
</template>
<style>

</style>
<script>

  import SearchChangeTchModal from './modal/SearchChangeTchModal'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

  export default {
    components: {SearchChangeTchModal},
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      return {
        cancelPermission: false,
        searchLoading: false,
        exportLoading: false,
        reloadWithPage: 0,
        reload: 0,
        rankScoreSeq: 0,
        tempLessonUser: {},
        changeTeacherOnly: false,
        optType: 3,
        showSearchChangeTchModal: false,
        queryParam: {
          courseType: '',
          oldTchId: '',
          oldTchName: '',
          newTchId: '',
          newTchName: '',
          uid: '',
          userMobile: '',
          userNickname: '',
          adviserNickname: '',
          studyAdviserNickname: '',
          startTimeDate: '',
          endTimeDate: '',
          startTime: '',
          endTime: '',
          startCreateDate: '',
          endCreateDate: '',
          startCreateTime: '',
          endCreateTime: '',
          adviserId: '',
        },
        title: [
          {
            title: '学生ID/姓名',
            fixed: 'left',
            width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('span', row.uid),
                h('br'),
                h('span', row.nickname)
              ])
            }
          },
          {
            title: '代课类型',
            align: 'center',
            key: 'type'
          },
          {
            title: '班主任',
            align: 'center',
            key: 'studyAdviserName'
          },
          {
            title: '原老师ID/姓名',
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: (row.beforeTchId != null ? row.beforeTchId + ' ' : '') + (row.oldTchName || ''),
                score: row.monthRankScore
              })
            }
          },
          {
            title: '新老师ID/姓名',
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: (row.afterTchId != null ? row.afterTchId + ' ' : '') + (row.newTchName || ''),
                score: row.monthRankScoreNew
              })
            }
          },
          {
            title: '操作人',
            width: 100,
            align: 'center',
            key: 'creatorName'
          },
          {
            title: '课程名称',
            width: 150,
            align: 'center',
            key: 'lessonTitle'
          },
          {
            title: '课程类型',
            width: 100,
            align: 'center',
            key: 'lsnType'
          },
          {
            title: '课程类别',
            align: 'center',
            width: 100,
            key: 'courseType'
          },
          {
            title: '原上课时间',
            align: 'center',
            key: 'lsnBeginTime'
          },
          {
            title: '新上课时间',
            align: 'center',
            key: 'lsnBeginTimeNew'
          },
          {
            title: '原课程状态',
            width: 120,
            align: 'center',
            key: 'lsnSelStatus'
          },
          {
            title: '新课程状态',
            width: 120,
            align: 'center',
            key: 'lsnSelStatusNew'
          },
          {
            title: '替换时间',
            align: 'center',
            key: 'gmtCreate'
          },
          {
            title: '操作',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let self = this
              if (self.cancelPermission !== true) {
                return ''
              }
              const row = params.row
              if (row.lsnSelStatusNew === '已选') {
                return h('div', [
                  h('a', {
                    on: {
                      click: () => {
                        this.cancelProxy(row)
                      }
                    }
                  }, '取消代课')
                ])
              } else {
                return h('div', [
                  h('span', { style: { color: '#999', cursor: 'not-allowed' } }, '取消代课')
                ])
              }
            },
          }
        ]
      }
    },
    mounted: function () {
      let self = this
      this.$http.post('/common/getPermissionByUrl', {url: '/cancel-proxy'}).then(function (res) {
        if (res.data === true) {
          self.cancelPermission = true
        }
      })
    },
    created: function () {
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
            onLoading (loading) {
        this.searchLoading = loading
        if (!loading) {
          this.loadMonthRankScores()
        }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = []
        table.forEach(function (row) {
          if (row.beforeTchId != null) { ids.push(row.beforeTchId) }
          if (row.afterTchId != null) { ids.push(row.afterTchId) }
        })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'beforeTchId', 'monthRankScore', map)
          applyTchScoresToRows(self, table, 'afterTchId', 'monthRankScoreNew', map)
        })
      },
      startTimeDateChange (value) {
        this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      cancelProxy (row) {
        this.tempLessonUser = row.bookLessonInfo
        this.showSearchChangeTchModal = true
        this.changeTeacherOnly = true
        this.optType = 3
      },
      searchWithPage () {
        this.reloadWithPage = new Date().getTime()
      },
      exportData (type) {
        this.exportLoading = true
        this.$http.get('/tchChange/list-export', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          if (response.data) {
            let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
            let link = document.createElement('a')
            link.target = '_blank'
            link.href = window.URL.createObjectURL(blob)
            link.download = '老师代课记录.xlsx'
            link.click()
            this.exportLoading = false
          } else {
            this.$Message.error(response.msg)
          }
        }).catch((e) => {
          this.exportLoading = false
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// ReplaceRecord.vue?7e54d040